module.exports = __webpack_public_path__ + "media/fastweb_volunteers/do-something-widget-bknd-ae76d53c.png";